// extracted by mini-css-extract-plugin
module.exports = {"securityPageWrapper":"API_securityPageWrapper__3utKL","securityPage":"API_securityPage__5hoCb","topImage":"API_topImage__xxMAC"};